import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Pagination from "./Pagination";
import SubTotal from "./SubTotal";

export default function DataTableServerSideRendering(props) {
  let {
    columns,
    data,
    equalWidth,
    miniHeader,
    miniRow,
    rowKey,
    pagination,
    activePage,
    totalPageCount,
    sortedColumn,
    setSortedColumn,
    sortDirection,
    setSortDirection,
    isRowBlue,
    selectableRow,
    rowSelection,
    isRowSelected,
    blueRowDirection,
    handleFetchData,
    subTotals,
  } = props;
  const [listedData, setListedData] = useState(data);

  // gelen data değişirse rerender etmeli
  useEffect(() => {
    setListedData(data);
    // default sorting field gelirse datayı gelen field'a göre sıralama
  }, [data]);

  const clickColumnHead = (sortable, selector) => {
    if (sortable) {
      const direction = sortDirection === "asc" ? "desc" : "asc";
      setSortedColumn(selector);
      setSortDirection(direction);
      handleFetchData(activePage, selector, direction.toUpperCase());
    }
    return;
  };

  const isBlue = (row) => {
    if (!blueRowDirection) return;
    return isRowBlue(row, blueRowDirection);
  };
  const rowClick = (e, row) => {
    // row selectable değilse devam etmemeli,
    if (!selectableRow) return;
    // row'un içinde TD harici herhangi bir elamana (input, button vb.) tıklanırsa rowSelection çalışmamalı
    if (e.target.tagName !== "TD") return;
    rowSelection(row);
  };

  const rowSelected = (row) => {
    // row selectable değilse devam etmemeli,
    if (!selectableRow) return;
    return isRowSelected(row);
  };
  return (
    <div
      className={`km__c--table ${
        equalWidth ? "km__c--table-is-equalwidth" : ""
      }`}
    >
      <div className="km__c--table-container">
        <table>
          <thead className={`${miniHeader ? "km__c-table-mini-header" : ""}`}>
            <tr>
              {columns.map((item) => {
                return (
                  <th
                    id={
                      item.key ? item.selector + "-" + item.key : item.selector
                    }
                    key={item.selector + "-" + item.key}
                    data-sortable={item.sortable}
                    onClick={() =>
                      clickColumnHead(item.sortable, item.selector)
                    }
                    width={item.width}
                    data-sort-direction={
                      item.selector === sortedColumn ? sortDirection : ""
                    } // sıralama iconu için
                  >
                    {item.name}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody
            className={`
              ${miniRow ? "km__c-table-mini-row" : ""} 
            `}
          >
            {listedData.map((dataItem, index) => {
              return (
                <tr
                  key={`${dataItem[rowKey]}-${index}`}
                  onClick={(e) => rowClick(e, dataItem)}
                  // className={
                  //   isBlue(dataItem) ? "km__c--table-mini-row-is-blue" : ""
                  // }
                  style={{
                    cursor: "pointer",
                  }}
                  className={`${
                    rowSelected(dataItem)
                      ? " km__c-table-has-selectable-row-is-selected"
                      : ""
                  }`}
                >
                  {columns.map((columnItem) => {
                    return (
                      <td
                        key={`${dataItem[rowKey]}-${columnItem.selector}-${columnItem.key}`}
                        title={
                          columnItem.showTitle && dataItem[columnItem.selector]
                        }
                      >
                        {/* özel renderlanacak olan bir cell varsa onu renderlar yoksa gelen value'yu renderlar */}
                        {columnItem.cell
                          ? columnItem.cell(dataItem)
                          : dataItem[columnItem.selector]}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
            {subTotals && subTotals.length > 0 ? (
              <SubTotal subTotals={subTotals} columnCount={columns.length} />
            ) : null}
          </tbody>
        </table>
      </div>
      {/* pagination prop'u aktifse pagination component'i renderlanır  */}
      {pagination ? (
        <div className="km__c--table-pagination-container">
          <Pagination
            length={totalPageCount}
            activePage={activePage + 1}
            onChange={(no) => {
              handleFetchData(
                no - 1,
                sortedColumn,
                sortDirection.toUpperCase()
              );
            }}
          />
        </div>
      ) : null}
    </div>
  );
}
DataTableServerSideRendering.propTypes = {
  subTotals: PropTypes.array,
  columns: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  equalWidth: PropTypes.bool,
  miniHeader: PropTypes.bool,
  miniRow: PropTypes.bool,
  rowKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  pagination: PropTypes.bool,
  totalPageCount: PropTypes.number,
  defaultSortedField: PropTypes.string,
  defaultSortAsc: PropTypes.bool,
  sortedColumn: PropTypes.string,
  setSortedColumn: PropTypes.func,
  sortDirection: PropTypes.string,
  setSortDirection: PropTypes.func,
  handleFetchData: PropTypes.func,
  selectableRow: PropTypes.bool,
  rowSelection: PropTypes.func,
  isRowSelected: PropTypes.func,
};
DataTableServerSideRendering.defaultProps = {
  subTotals: [],
  columns: [],
  data: [],
  equalWidth: false,
  miniHeader: false,
  miniRow: false,
  rowKey: "id",
  pagination: false,
  selectableRow: false,
};
